export const setToggleSideMenuKey="@UIContext/SET_TOGGLED_SIDE_MENU_STATUS";
export const setSideMenuStatusKey="@UIContext/SET_SIDE_MENU_STATUS";
export const setPageLoaderKey="@UIContext/SET_PAGE_LOADER";
export const setRouteKey="@UIContext/SET_CURRENT_ROUTE";
export const setFlashMessageKey="@UIContext/SET_FLASH_MESSAGE";
export const removeFlashMessageKey="@UIContext/REMOVE_FLASH_MESSAGE";
export const addFlashMessageKey="@UIContext/ADD_FLASH_MESSAGE";
export const setPickRequestCountKey="@UIContext/SET_PICK_REQUEST_COUNT";
export const getPickRequestCountKey="@UIContext/GET_PICK_REQUEST_COUNT";
